import { A } from "@ember/array"
import Component from "@ember/component"
import { action, computed, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import _ from "lodash"
import styles from "./week.module.css"
// import { payloadForComponent } from "../../../lib/action-creators/app-state"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Session from "cc-frontend/services/session"
import type { Moment } from "cc-frontend/utils/extended-moment"
import moment from "cc-frontend/utils/extended-moment"
import { first, last } from "lodash-es"
import draggableLessons from "../../../mixins/draggable-lessons"

export default class Week extends Component.extend(draggableLessons) {
  readonly styles = styles

  // Services
  @service declare modalManager: ModalManager
  @service declare session: Session

  // Args
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  setNewDate!: Function
  date!: string
  courses!: Array<Course>
  isFilteringClasses!: boolean
  classesLinedUp!: boolean
  lessonsCollapsed!: boolean
  daysAsRows!: boolean
  showAllClasses!: Function
  filterClasses!: Function
  toggleCourseId!: Function
  showClassesInOrder!: Function
  showClassesLinedUp!: Function
  showDaysAsRows!: Function
  showDaysAsColumns!: Function
  expandLessons!: Function
  collapseLessons!: Function
  editCourseTitleAndOrder!: Function
  onCourseCreate!: Function
  showTemplateChooser!: Function
  onTemplateChooserClose!: Function
  unitId!: string
  hiddenCourseIds: Array<string> = []
  closeMenu!: Function

  // Properties
  sortableChildren = A([])
  hoveringDateString = null

  @service dragging
  @service("ember-store") store

  addSortableChild(child) {
    // @ts-ignore
    this.sortableChildren.addObject(child)
  }

  removeSortableChild(child) {
    // @ts-ignore
    this.sortableChildren.removeObject(child)
  }

  canReceiveSortable(_node) {
    return false
  }

  // Init

  // Computed/Getters
  // If it's the week view, we replace. Otherwise, we append
  @computed("date")
  get dateStrings() {
    let validSchoolDays = this.rotationCalendar.attributes.schoolDays
    let date = this.date

    let startDate = moment(date).startOf("week")
    let endDate = moment(date).endOf("week")

    let range = moment.range(startDate, endDate)
    let acc: Moment[] = []
    Array.from(range.by("days")).map((moment) => {
      if (_.includes(validSchoolDays, moment.weekday())) acc.push(moment)
    })
    let newDates = _.uniq(_.map(acc, (m) => m.format("YYYY-MM-DD")))

    return newDates
  }

  @computed("dateStrings.[]")
  get dateRangeString() {
    var start = moment(_.first(this.dateStrings))
    var end = moment(_.last(this.dateStrings))
    var startMonth = start.format("MMMM")
    var endMonth = end.format("MMMM")
    if (startMonth === endMonth) {
      return start.format("MMMM D") + " - " + end.format("D, YYYY")
    } else {
      return start.format("MMM. D") + " - " + end.format("MMM. D, YYYY")
    }
  }

  // Actions
  @action
  page(direction) {
    let op = direction === "back" ? "subtract" : "add"
    let date = get(this, "date")
    let newDate = moment(date)[op](1, "week")
    // change to adjust to
    this.setNewDate(newDate.format("YYYY-MM-DD"))
  }

  @action
  hoverOnDate(dateString) {
    set(this, "hoveringDateString", dateString)
  }

  @action
  printOrDownload() {
    if (this.session.isAuthenticated !== true) {
      this.session.mustSignInToProceed("Print/Download Day")
      return
    }

    let startDate = first(this.dateStrings)
    let endDate = last(this.dateStrings)

    if (_.includes(this.session.user.content.meta.permissions, "can-print-week")) {
      this.modalManager.openModal("planner/modals/print-download", {
        courseIds: _.chain(this.courses)
          .map((course) => course.id)
          .reject((courseId) => _.includes(this.hiddenCourseIds, courseId))
          .value(),
        isFilteringClasses: this.isFilteringClasses,
        classesLinedUp: this.classesLinedUp,
        planbookId: this.planbook.id,
        startDate: startDate,
        endDate: endDate,
        currentUserId: this.session.userId,
        dateRangeString: this.dateRangeString,
        layout: "planbook-date:range:columns",
        canPrint: _.includes(this.session.user.content.meta.permissions, "can-print-week"),
      })
    } else {
      this.modalManager.openModal("planner/modals/print-paywall", {})
    }
  }
}
